import { getRuntimeConfig, initAxiosAuthClient } from '@hclinear/hc-linear-react';
import { initializeSentry } from '@configuration/sentry.config';

export const initHcLinearConfig = () => {
  initializeSentry();
  initAxiosAuthClient(getRuntimeConfig().AUTH_BACKEND_URL);
};
